import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, Attributes, SubTypeMap} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class AffectedLotLabelExpressionBuilder {
    title = 'AffectedLotLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {
        this.init();
    }

    private init() {
        this.subTypeMap[1] = {function: this.buildAffectedLotAnnotation.bind(this)};
    }

    build(attributes: Attributes) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes);
    }

    formatLabel(value: string, size: number, normal: boolean) {
        return this.labelExpressionUtilityService.formatLabel(value, size, normal);
    }

    getLabelProperties(fontSize: string, fontStyle: string, textAnchor: string, attributes: string) {
        return this.labelExpressionUtilityService.getLabelProperties(
            fontSize,
            fontStyle,
            textAnchor,
            this.labelExpressionUtilityService.encodeSpecialCharacters(attributes)
        );
    }

    buildAffectedLotAnnotation(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        let labels = [];
        let labelProperties = {} as labelProperties;
        let labelExpression = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute1));
        }

        if (attributes.attribute2) {
            let prefix = '';

            if (attributes.attribute5 === 'TRUE') {
                prefix = 'CP';
            }

            attribute2 = this.formatLabel(prefix + attributes.attribute2, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', prefix + attributes.attribute2));
        } else {
            if (attributes.attribute5 === 'TRUE') {
                attribute2 = this.formatLabel('COMMON PROPERTY', 14, false) + '\n';
                labels.push(this.getLabelProperties('14em', 'italic', 'middle', 'COMMON PROPERTY'));
            }
        }

        if (attributes.attribute3) {
            attribute3 = this.formatLabel(attributes.attribute3, 10, true) + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'normal', attributes.attribute3));
        }

        if (attributes.attribute4) {
            attribute4 = this.formatLabel(attributes.attribute4, 10, true) + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute4));
        }

        labelExpression = (attribute1 + attribute2 + attribute3 + attribute4).replace(new RegExp('\n$'), '');
        if (labelExpression !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelExpression;
            return labelProperties;
        } else {
            return null;
        }
    }
}
